export function initializeCustomSlider() {

    // CUSTOM CAROUSEL
    new Swiper('.myCustomSlider', {
        slidesPerView: 2,
        loop: true,
        spaceBetween: 30,
        speed: 600,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            0: { slidesPerView: 1 },
            768: { slidesPerView: 1 },
            991: { slidesPerView: 2 }
        }
    });

    // CASE STUDIES CAROUSEL
    new Swiper('.myCaseSwiper', {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 20,
        speed: 600,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // ARTICLES SWIPER
    const articleWrapper = document.querySelector('.myArticleSwiper');
    const articleControls = document.querySelector('.article-swiper-controls');

    if (articleWrapper) {
        const articleCount = articleWrapper.querySelectorAll('.swiper-slide').length;

        function getArticleSlidesPerView() {
            if (window.innerWidth >= 1440) return 3;
            if (window.innerWidth >= 768) return 2;
            return 1;
        }

        function updateArticleNavVisibility() {
            if (!articleControls) return;
            const perView = getArticleSlidesPerView();
            articleControls.style.display = articleCount > perView ? '' : 'none';
        }

        new Swiper('.myArticleSwiper', {
            slidesPerView: 3,
            spaceBetween: 30,
            speed: 600,
            pagination: {
                el: '.article-swiper-controls .swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.article-swiper-controls .swiper-button-next',
                prevEl: '.article-swiper-controls .swiper-button-prev',
            },
            breakpoints: {
                0: { 
                    slidesPerView: 1.15, 
                    spaceBetween: 16,
                    slidesOffsetBefore: 30,
                },
                768: { 
                    slidesPerView: 2,
                    slidesOffsetBefore: 0,
                },
                1440: { 
                    slidesPerView: 3,
                    slidesOffsetBefore: 0,
                }
            },
            on: {
                init: updateArticleNavVisibility,
                resize: updateArticleNavVisibility,
            }
        });
    }

}